<template>
  <div class="list-page-header">
    <h3 class="title">{{ $t("program.manager_program") }}</h3>
    <md-button
      v-if="canAdd"
      class="md-success btn-search ml-6"
      @click="go2AddPage"
    >
      {{ $t("common.add_new") }}
    </md-button>
  </div>
</template>

<script>
import { program_router_names } from "@/routes/routes";
import { Program } from "@/constants/Permissions";

export default {
  name: "ListPageHeader",
  computed: {
    canAdd() {
      return this.$can(Program.actions.add, Program.subject);
    }
  },
  methods: {
    go2AddPage() {
      this.$router.push({ name: program_router_names.addPage });
    }
  }
};
</script>
